import type { Locale } from '@tuic/i18n';
import { CacheTag } from '../../utils';
import { remember, serializeDataToCacheKey } from '@tuic/cache';
import { Pcl } from '../../index';
import { logger } from '@tuic/logger';

/**
 * Fetches the ship details from the PCL API.
 */
export const getRegions = async (locale: Locale): Promise<Pcl.Region[]> => {
  let { data, error } = await Pcl.getRegions({ query: { locale } });

  if (error) {
    logger.error(`Could not fetch regions. Locale: ${locale}`);
    logger.error(error);

    return [];
  }

  return data ?? [];
};

/**
 * Fetches the ship details from the PCL API.
 */
export const cachedGetRegions = (locale: Locale): Promise<Pcl.Region[]> =>
  remember(
    serializeDataToCacheKey([CacheTag.pcl, 'getRegions', locale]),
    () => getRegions(locale),
    {
      tags: [CacheTag.pcl, CacheTag.regionResource, CacheTag.getRegions],
      ttl: 600,
    },
  );
